<template>
  <div
    id="page"
    class="page"
  >
    <router-view></router-view>
  </div>
  <ModalPedidos
    v-if="modalPedidosVisible"
    title="Seleccionar pedido"
    :visible="modalPedidosVisible"
    @close-modal="() => (modalPedidosVisible = false)"
    @orders-selected="() => (modalPedidosAOpVisible = true)"
  />

  <ModalPedidosAOp
    v-if="modalPedidosAOpVisible"
    :visible="modalPedidosAOpVisible"
    @close-modal="() => (modalPedidosAOpVisible = false)"
  />
</template>

<script setup>
import {
  onMounted,
  ref,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useConfiguracionStore } from '@/stores/configuracion-general.js';
import { useWorkOrderStore } from './stores/work_order_store.js';
import ModalPedidos from './work_order_list/components/modal_pedidos.vue';
import ModalPedidosAOp from './work_order_list/components/modal_pedidos_a_op.vue';

const configuracionStore = useConfiguracionStore();
const workOrderStore = useWorkOrderStore();

const { modalPedidosVisible } = storeToRefs(workOrderStore);

const modalPedidosAOpVisible = ref(false);

onMounted(async () => {
  await configuracionStore.firstConfiguraciones();
});
</script>

<style scoped>
.page {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
